import styled from 'styled-components';

export const Wrapper = styled.div`

div {
  background-color: #fff;
}

form ._2lUSM {
  margin-bottom: 15px;
}

.mensaje {
  margin-bottom: 20px;
}

.dato-comprobante-header{
  ._E_S3q{
    h2{
      font-size: 0.9rem !important;
      font-weight: 400;
      color: #383838;
    }
  }
}

.px-row {
  padding: 20px 32px;
}

.datoComprobante{
    ._E_S3q {
      h1{
        font-size: 1rem !important;
      }
      h2{
        font-size: 0.9rem !important;
        font-weight: 400;
        color: #383838;
      }
    }
}

.footer{
    p{
      font-size: 0.9rem;
      color: #383838;
      b{
        font-weight: bolder;
        color: black;
      }
    }
    p:nth-child(2){
      margin-top: 30px;
    }
}

._sqrUW {
  font-size: 1.5rem !important;
  line-height: 1.5;
}

.horario {
  margin-bottom: 0px;
}
.horario .titulo {
  font-size: 1rem;
  line-height: 1.5;
  font-weight: bold;
  margin-top: -10px;
  margin-bottom: 11px;
}
.datoComprobante ._3pNgQ ._3b-4_ ._sqrUW {
  font-size: 1.2rem;
}
.horario p {
  font-size: 0.8rem;
  line-height: 1.5;
  font-weight: 400;
}
.dato{
  color: #383838;
}
.sello {
  margin-bottom: 20px;
  position: relative;
  text-align: end;
}
.sello p {
  display: none;
}
.mensajeInfo {
  margin-bottom: 20px;
  margin-top: 20px;
}
.mensajeInfo div {
  background-color: #c0e9fd;
}
.footer hr {
  margin-left: -32px;
  margin-right: -32px;
}
.contenedor {
  display: grid;
  grid-template-columns: 1fr;
  text-align: center;
  gap: 32px;
}
.info .p-mensaje {
  font-weight: bold;
  line-height: 19px;
}
.info .p-coment {
  margin-top: 4px;
}
._3pNgQ ._3b-4_ ._mNm5q {
  font-size: 0.8rem;
  line-height: 1.5;
  font-weight: 400;
}
.sello img {
  width: 7rem;
  margin: -3px 20px -93px 1px;
}
@media (max-width: 425px) {
  ._sqrUW {
      font-size: 1.1rem !important;
      line-height: 1.5;
  }
  .horario {
    margin-bottom: 24px;
  }
  .horario .titulo {
      font-size: 1.1rem;
      line-height: 1.5;
  }
  ._3pNgQ ._3b-4_ ._mNm5q {
      font-size: 0.8rem;
      line-height: 1.5;
      font-weight: 400;
      margin-top: 5px;
      margin-bottom: -10px;
  }
  .sello {
      margin-bottom: 0px;
      display: grid;
      grid-template-columns: 0.5fr 1fr;
  }
  .sello img {
      width: inherit;
      margin: inherit;
  }
  .sello p {
      margin-top: 37px;
      margin-left: 15px;
      color: #a5a5a5;
      font-size: 0.75rem;
      width: fit-content;
      display: inherit !important;
  }
  .footer {
      display: none;
  }
  .title-content {
    z-index: 9;
  }
}
@media (max-width: 375px) {
  ._sqrUW {
      font-size: 1.1rem !important;
      line-height: 1.5;
  }
  .horario .titulo {
      font-size: 1rem;
      line-height: 1.5;
  }
  ._3pNgQ ._3b-4_ ._mNm5q {
      font-size: 0.8rem;
      line-height: 1.5;
      font-weight: 400;
      margin-top: 5px;
      margin-bottom: -10px;
  }
  .sello {
      display: grid;
      grid-template-columns: 0.5fr 1fr;
  }
  .sello img {
      width: inherit;
      margin: inherit;
  }
  .sello p {
      margin-top: 37px;
      margin-left: 15px;
      color: #a5a5a5;
      font-size: 0.75rem;
      width: fit-content;
      display: inherit !important;
  }
  .footer {
      display: none;
  }
}
@media (max-width: 320px) {
  ._3pNgQ ._3b-4_ ._sqrUW {
      font-size: 1.1rem !important;
      line-height: 1.5;
  }
  ._3pNgQ ._3b-4_ ._mNm5q {
      font-size: 0.8rem;
      line-height: 1.5;
      font-weight: 400;
      margin-top: 5px;
      margin-bottom: -10px;
  }
  .horario .titulo {
      font-size: 0.9rem;
      line-height: 1.5;
  }
  .horario p {
      font-size: 0.7rem;
      font-weight: 400;
  }
  .sello {
      display: grid;
      grid-template-columns: 0.5fr 1fr;
  }
  .sello img {
      width: inherit;
      margin: inherit;
  }
  .sello p {
      margin-top: 37px;
      margin-left: 15px;
      color: #a5a5a5;
      font-size: 0.75rem;
      width: fit-content;
      display: inherit !important;
  }
  .footer {
      display: none;
  }
  .dato-comprobante-header{
    ._E_S3q{
      h2{
        font-size: 0.8rem !important;
        font-weight: 400;
        color: #383838;
      }
    }
  }
  
  .datoComprobante{
      ._E_S3q {
        h1{
          font-size: 0.9rem !important;
        }
        h2{
          font-size: 0.8rem !important;
          font-weight: 400;
          color: #383838;
        }
      }
  }
}
   
`;

export const StyledWrapperCardBaseButtons = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  & > button {
    margin: 0;
    padding: 0;
    border: 0;
    background-color: transparent;
    color: #f42534;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    justify-content: space-around;
    align-items: center;
    & > span {
      margin-right: 0.5rem;
    }
  }
`;

export default Wrapper;